import { render, staticRenderFns } from "./showUpgrade.vue?vue&type=template&id=60962b1c&scoped=true&"
import script from "./showUpgrade.vue?vue&type=script&lang=js&"
export * from "./showUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./showUpgrade.vue?vue&type=style&index=0&id=60962b1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60962b1c",
  null
  
)

export default component.exports